import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Page2 from "../views/Page2.vue";
import Page3 from "../views/Page3.vue";
import Prayer from "../views/Prayer.vue";
import Select from "../views/Select.vue";
import Result from "../views/result.vue";
import Loykathong from "../views/Loykathong.vue";
import Thank from "../views/Thank.vue";
import store from "../store/index";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Select",
    component: Select,
  },
  {
    path: "/page2",
    name: "Page2",
    component: Page2,
  },
  {
    path: "/page3",
    name: "Page3",
    component: Page3,
  },
  {
    path: "/prayer",
    name: "Prayer",
    component: Prayer,
  },
  {
    path: "/home",
    name: "Home",
    component: Home,
  },
  {
    path: "/result",
    name: "Result",
    component: Result,
  },
  {
    path: "/loykathong",
    name: "Loykathong",
    component: Loykathong,
  },
  {
    path: "/thank",
    name: "Thank",
    component: Thank,
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach((to, from, next) => {
  if (from.name) {
    if (to.path !== "/") {
      store.dispatch("setFrom", JSON.parse(localStorage.getItem("form")));
    } else {
      store.dispatch("clearForm");
    }
    next();
  } else {
    if (to.name !== "Select") {
      store.dispatch("clearForm");
      next({ name: "Select" });
    } else {
      next();
    }
  }
});

export default router;
